import React from 'react';
import { Grid, Tooltip } from '@material-ui/core';
import Typography from '@material-ui/core/typography';
import { withStyles, makeStyles } from '@material-ui/core/styles';
import Switch from '@material-ui/core/switch';
import Icon from '@material-ui/core/Icon';


const AntSwitch = withStyles(theme => ({
  root: {
    width: 28,
    height: 16,
    padding: 0,
    display: 'flex',
  }
}))(Switch);

const useStyles = makeStyles({
  ukIcon: {
    height: 24,
    width: 24
  },
  brIcon: {
    height: 16,
    width: 23,
    marginTop: 4,
    marginLeft: 1
  },
  iconRoot: {
    textAlign: 'center'
  }
});

const Language = props => {
  const handleChange = name => event => {
    setState({ ...state, [name]: event.target.checked });
  };
  const classes = useStyles();
  const [state, setState] = React.useState({
    checkedA: true,
    checkedB: true,
    checkedC: true,
  });
  return (
    <Typography component="div" >
      <Grid component="label" container alignItems="center" spacing={1} style={{ justifyContent: 'center', position: 'initial', bottom: 0, marginTop: '4vh' }}>
        Language
      </Grid>
      <Grid component="label" container alignItems="center" spacing={1} style={{ justifyContent: 'center', position: 'initial', bottom: 0, marginTop: '1vh' }}>
        <Tooltip title="Português" placement="top">
          <Icon>
            <img alt="Português" className={classes.brIcon} src="/images/flags/br.svg" />
          </Icon>
        </Tooltip>
        <Grid item>
          <AntSwitch checked={state.checkedC} onChange={handleChange('checkedC')} value="checkedC" />
        </Grid>
        <Tooltip title="English" placement="top">
          <Icon>
            <img alt="English" className={classes.ukIcon} src="/images/flags/uk.svg" />
          </Icon>
        </Tooltip>
      </Grid>
    </Typography>
  );
};

export default Language;